import fetch_retry from "./Fetch/RetryFetch";

export const getOportunity = async (origin, name, token, noCache) => {
  const config = noCache ? { cache: "no-cache" } : {};
  let tenant = origin.split("//")[1];
  return await fetch_retry(
    `https://apipro.agentemotor.com/seguros/crm/get_opportunity_offers?id_opportunity=${name}&tenant_name=${tenant}&access_token=${token}`,
    config,
    3
  ).then((res) => {
    return res.json();
  });
};
